import React, { useEffect } from 'react'
import successImg from "../../Assets/images/success-img.svg"
import MainLogo from "../../Assets/images/short-logo-white.svg"

import { useNavigate } from 'react-router-dom'
import useMakeRequest from '../../utils/ApiHelper'
import { useLocation } from 'react-router-dom'
import { ApiConstants } from '../../constants/ApiConstants'
import FrontLoader from './FrontLoader'
import { socket } from '../../utils/Socket'


function Success() {
    const PaymentStatus = useMakeRequest()
    const navigate  = useNavigate()
    const loaction = useLocation()
    const ID = loaction?.search?.split('?success=')

  const handleNavigateHome =()=>{
    navigate('/')
  }


  useEffect(()=>{
  if(ID.length  > 0){
  const payload ={
    type:'web',
    payment_type:0,
    paymeny_status:'success',
    payment_id:ID[1]
    }
    const socketpayload ={
                sender_type: "1",
                receiver_id: '1'
      }
      socket.emit('admin_count', socketpayload, async (Response: any) => {
        })
    PaymentStatus.makeRequest({ payload, url: ApiConstants?.OrderStatus, toastStatus: false })
  }
  },[])


  return (
    <>
    {PaymentStatus.loading ? <FrontLoader/> : null}
     <div className="modal fade com-modal short-modal success-modal text-center show" id="successModal" aria-labelledby="successModalLabel" aria-hidden="true" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body py-0">
                           <img src={MainLogo} alt="Logo" className="background-logo"/> 
                            <img className="success-img" src={successImg} alt="" />
                           <div className="success-heading">Successful</div>
                           <div className="px-5 mb-4">
                                <p>Your order has been successfully placed </p>
                                <p>Invoice will be sent on your registered email.</p>
                           </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="round-btn m-0 w-100" onClick={()=>handleNavigateHome()} >Go to Home</button>
                        </div>
                    </div>
                </div>
      </div>
    </>
  )
}

export default Success